import React from 'react';

const ScheduleScreen = () => {
  return <>업무 스케쥴</>;
};

export default ScheduleScreen;
